// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Container,
  Row,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import {
  PAYMENT_PROVIDER_API,
  UPDATE_PAYMENT_PROVIDER_API,
  CREATE_PAYMENT_PROVIDER_API,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiImageUploadService,
  putApiDataService,
} from "../../services/apiServices";
import CreatePaymentProviderModal from "./payments/CreatePaymentProviderModal";
import EditPaymentProviderModal from "./payments/EditPaymentProviderModal";
import { DataTable, FilterBar, StatusBadge } from "components/shared";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "name", label: "Name" },
  { key: "type", label: "Type" },
  { key: "regions", label: "Regions" },
  { key: "status", label: "Status" },
  { key: "actions", label: "" },
];

const PaymentProviderList = () => {
  const history = useHistory();
  const [paymentProviders, setPaymentProviders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [item, setitem] = useState(null);

  useEffect(() => {
    fetchPaymentProviders();
  }, []);

  const fetchPaymentProviders = () => {
    setIsLoading(true);
    getApiDataService(PAYMENT_PROVIDER_API)
      .then((res) => {
        setPaymentProviders(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setPaymentProviders([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const handleCreateClick = () => {
    console.log("Create item");
    setShowCreateModal(true);
  };

  const handleEditClick = (item) => {
    console.log("Edit item", item);
    setitem(item);
    setShowEditModal(true);
  };

  const handleModalBoxCancel = () => {
    setShowEditModal(false);
    setShowCreateModal(false);
  };

  const handleUpdateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    putApiDataService(UPDATE_PAYMENT_PROVIDER_API(item?.id), data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowEditModal(false);
        fetchPaymentProviders();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error in handleUpdateSubmit!", err);
      });
  };

  const handleCreateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    postApiImageUploadService(CREATE_PAYMENT_PROVIDER_API, data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowCreateModal(false);
        fetchPaymentProviders();
      })
      .catch((err) => {
        console.log("Error in handleCreateSubmit!", err);
        setIsLoading(false);
      });
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="Payment Provider List">
                  <button
                    onClick={() => handleCreateClick()}
                    className="btn btn-sm btn-primary"
                  >
                    Create
                  </button>
                </FilterBar>
              </CardHeader>
              <DataTable
                columns={COLUMNS}
                data={paymentProviders}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(payment_provider, index) => (
                  <tr key={payment_provider?.id ?? index}>
                    <th>{index + 1}</th>
                    <th scope="row">
                      <Media className="align-items-center">
                        <a
                          className="avatar rounded-circle mr-3"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <img
                            alt="..."
                            src={payment_provider?.logo}
                            style={{ width: "60px" }}
                          />
                        </a>
                        <Media>
                          <span className="mb-0 text-sm">
                            {payment_provider?.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{payment_provider?.payment_type}</td>
                    <td>
                      <span className="mb-0 text-lg">
                        <Badge color="warning" pill>
                          {payment_provider?.region.country_name}
                        </Badge>
                      </span>
                    </td>
                    <td>
                      <StatusBadge status={payment_provider?.status} />
                    </td>
                    <td className="text-right">
                      <div className="row">
                        <div className="col">
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => handleEditClick(payment_provider)}
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              />
            </Card>
          </div>
        </Row>
      </Container>
      {showEditModal && (
        <EditPaymentProviderModal
          item={item}
          isLoading={isLoading}
          onClose={handleModalBoxCancel}
          onSubmit={handleUpdateSubmit}
        />
      )}
      {showCreateModal && (
        <CreatePaymentProviderModal
          onClose={handleModalBoxCancel}
          onSubmit={handleCreateSubmit}
        />
      )}
    </>
  );
};

export default PaymentProviderList;
